module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hello":"Cancellation of Xindong account application"},"zh":{"hello":"注销心动账号申请"}}')
  delete Component.options._Ctor
}
